// extracted by mini-css-extract-plugin
export default {"illustration":"promote_illustration__f7LgY","ellipsis":"promote_ellipsis__pEI90"};